import type { RangeKnob } from './knobs';
import type { AnimationConfig } from './types';

/** The slot lane's own knobs — `options.slot` of a slot-lane config. */
export interface SlotOptions {
  /** The lane's pack size as a multiple of the template's own; 1 = as is. */
  packScale?: number;
}

/**
 * The slot lane's pack size. A multiple of the template's own tile width, so
 * every template keeps its size until the operator moves the slider; the
 * lane still caps the pack by the screen height on top of it.
 */
export const SLOT_PACK_SCALE_KNOB: RangeKnob = {
  path: 'slot.packScale',
  label: 'Pack size',
  group: 'Pack',
  kind: 'range',
  min: 0.75,
  max: 1.5,
  step: 0.01,
  format: 'x',
  defaultValue: 1,
  variants: ['slot'],
};

/** The slot lane's pack size multiplier for `animation`; 1 for any other mechanic. */
export function slotPackScale(animation: AnimationConfig): number {
  if (animation.variant !== 'slot') return SLOT_PACK_SCALE_KNOB.defaultValue;
  const raw = animation.options?.slot?.packScale;
  if (typeof raw !== 'number' || !Number.isFinite(raw)) return SLOT_PACK_SCALE_KNOB.defaultValue;
  return Math.min(SLOT_PACK_SCALE_KNOB.max, Math.max(SLOT_PACK_SCALE_KNOB.min, raw));
}
